// Libraries
import Splide from '@splidejs/splide';

// Template parts
import './parts/utilities.js';
import './parts/sidebar.js';
import './parts/category.js';

window.addEventListener('DOMContentLoaded', function() {

    // Custom image gallery buttons
    const gallery = document.querySelector('.woocommerce-product-gallery--with-images');
    
    if( gallery ){

        function observe_gallery(mutationList, observer){
            for (const mutation of mutationList) {
                if (mutation.type === "childList") {
                    for (let node of mutation.addedNodes) {
                        if ( node.nodeType === 1 && node.classList.contains("flex-control-thumbs")) {
                            create_gallery_arrows();
                            observer.disconnect();
                        }
                    }
                }
            }
        }

        const observer = new MutationObserver(observe_gallery);
        observer.observe(gallery, { attributes: false, childList: true, subtree: true });


        function create_gallery_arrows(){
            const viewport = document.querySelector('.woocommerce-product-gallery--with-images .flex-viewport');
            let nav = document.createElement('div');
            nav.className = 'gallery-arrows';
            nav.innerHTML = `<button class="gallery-arrow gallery-arrow--prev"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z" fill="white"/></svg></button><button class="gallery-arrow gallery-arrow--next"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z" fill="white"/></svg></button>`;
            viewport.appendChild(nav);

            const buttons = document.querySelectorAll('.woocommerce-product-gallery--with-images .gallery-arrow');

            for (let i = 0; i < buttons.length; i++) {
                const button = buttons[i];
                button.addEventListener('click', handle_gallery_arrow_click);
            }

        }

        function handle_gallery_arrow_click(e){

            let thumbs          = document.querySelectorAll('.flex-control-thumbs li img');
            let current         = document.querySelector('.flex-control-thumbs .flex-active');
            thumbs              = Array.from(thumbs);
            let current_index   = thumbs.indexOf(current);
            let max_length      = thumbs.length;
            let new_index       = 0;

            if( e.currentTarget.classList.contains('gallery-arrow--prev') ){
                new_index = current_index - 1 >= 0 ? current_index - 1 : max_length - 1;
            }
            
            if( e.currentTarget.classList.contains('gallery-arrow--next') ){
                new_index = current_index + 1 < max_length ? current_index + 1 : 0;
            }

            jQuery('.woocommerce-product-gallery').flexslider(new_index)
            return;
            
        }

    }

    // Related products
    const related = document.querySelector( '.related.products' );

    if( related ){

        const products = related.querySelectorAll('li.product')
        Array.from(products).map( product => product.classList.add('splide__slide') );

        const args = {
            type   : 'loop',
            perPage: 4,
            perMove: 1,
            gap: '4rem',
            pagination: true,
            arrows: true,
            focus  : 0,
            omitEnd: true,
            speed: 400,
            autoplay: true,
            breakpoints:{
                800: {
                    perPage: 3,
                },
                660: {
                    perPage: 2,
                }
            }
        }
        
        const el = related.querySelector('.splide');
        let slider = new Splide( el, args );
        slider.mount();

    }

    // Update SKU field for variations
    let sku = document.querySelector('.product-sku');
    if(sku){
        jQuery("form.variations_form").on("show_variation", function (event, variation) {
            if( variation.sku ){
                sku.innerHTML = '#' + variation.sku;
            }
        });
            
        jQuery(document).on('click', '.reset_variations', function() {
            sku.innerHTML = "";
        });
    }
    
});